import { Hex } from 'js/bubbleCore/Hex';
import { directionCubeOffsets, IHexGridData, HexGridType } from 'js/bubbleCore/types';
import { isInGrid } from 'js/bubbleCore/utils/isInGrid';
import { getGridValue } from 'js/bubbleCore/utils/getGridValue';

export function getNeighbours<T>(
  grid: IHexGridData<T>, col: number, row: number
): T[] {
  if (grid.type === HexGridType.OddR) {
    return getNeighboursOddR(grid, col, row);
  }

  const tempHex = new Hex(grid.type);
  const tempHex2 = new Hex(grid.type);

  const result: T[] = [];

  Object.values(directionCubeOffsets).forEach(([x, y, z]) => {
    tempHex.setOffset(col, row);
    tempHex2.setCube(x, y, z);
    tempHex.add(tempHex2);
    if (isInGrid(grid, tempHex.offsetPosition.x, tempHex.offsetPosition.y)) {
      const val = getGridValue(grid, tempHex.offsetPosition.x, tempHex.offsetPosition.y);
      val && result.push(val);
    }
  });

  return result;
}


// performance versions
const oddRCoords = [
    [[-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, 0]],
    [[0, -1], [-1, 0], [0, 1], [1, -1], [1, 1], [1, 0]],
];

function getNeighboursOddR<T>(grid: IHexGridData<T>, col: number, row: number): T[] {
  const result: T[] = [];

  oddRCoords[row % 2].forEach((coords) => {
    if (isInGrid(grid, col + coords[0], row + coords[1])) {
      const val = getGridValue(grid, col + coords[0], row + coords[1]);
      val && result.push(val);
    }
  });

  return result;
}